import { BodyText } from '@/shared/components/StyledText';
import { accent, green } from '@/shared/styles/colors';
import { toTitleCase } from '@/shared/utils';
import styled from '@emotion/native';
import React from 'react';

const TabItem = ({
  selected,
  onPress,
  text,
  isLastItem,
  isStylist = false,
}: {
  selected: boolean;
  onPress: () => void;
  text: string;
  isLastItem: boolean;
  isStylist?: boolean;
}) => {
  return (
    <Item onPress={onPress} isLastItem={isLastItem}>
      <TextContainer>
        <TabText
          isStylist={isStylist}
          selected={selected}
          allowFontScaling={false}
        >
          {toTitleCase(text)}
        </TabText>
        {selected && <SelectedIndicator />}
      </TextContainer>
    </Item>
  );
};

const Item = styled.TouchableOpacity<{ isLastItem: boolean }>(
  ({ isLastItem }) => ({
    flex: 1,
    alignItems: 'center',
    marginRight: isLastItem ? 0 : 25,
  }),
);

const TextContainer = styled.View({
  position: 'relative',
});

const TabText = styled(BodyText)<{ selected?: boolean; isStylist?: boolean }>(
  ({ selected, isStylist }) => ({
    color: green,
    fontWeight: selected ? 'bold' : 'normal',
    textAlign: 'center',
    margin: 0,
    fontSize: isStylist ? 13 : 14,
  }),
);

const SelectedIndicator = styled.View({
  position: 'absolute',
  bottom: -6,
  left: 0,
  right: 0,
  height: 6,
  backgroundColor: accent,
  borderRadius: 20,
});

export default TabItem;
